// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";

// User components
import First from "./components/Home/First/First";
import About from "./components/Home/About_Our_Chapter/About";
import Announcement from "./components/Home/Announcement/Announcement";
import SingleAnnouncement from "./components/Home/Announcement/SingleAnnouncement";
import Team from "./components/Home/Team/Team";
import HomeBlogs from "./components/Blogs/Blogs";
import Events from "./components/Events/Events";
import Gallery from "./components/Gallery/Gallery";
import Benefits from "./components/Benefits/Benefits";
import EventCalendar from "./components/Calendar/EventCalendar";
// Import the new OurTeam component
import OurTeam from "./components/Our_Team/Our_Team";
import Popup from "./components/Popup/Popup";
import Splash from "./components/Splash/Splash";
import Developer from "./components/Developer/Developer";
import ScrollToTop from "./components/common/ScrollToTop";

import "./App.css";

function AppContent() {
  return (
    <Router>
      <ScrollToTop />
      <Header />
      <Popup />
      <Routes>
        <Route
          path="/"
          element={
            <>
              {/* Home page now contains only the scrolling components that are NOT dedicated pages */}
              <First />
              <About />
              <Announcement />
              <Team />
              {/* REMOVED <Team /> from the homepage element list */}
            </>
          }
        />

        {/* DEDICATED ROUTE: Blogs Page */}
        <Route path="/blogs" element={<HomeBlogs />} />

        {/* DEDICATED ROUTE: Events Page */}
        <Route path="/events" element={<Events />} />

        {/* NEW DEDICATED ROUTE: Our Team Page */}
        <Route path="/ourteam" element={<OurTeam />} />

        <Route path="/gallery" element={<Gallery />} />

        <Route path="/benefits" element={<Benefits />} />

        <Route path="/calendar" element={<EventCalendar />} />

        <Route path="/developer" element={<Developer />} />

        <Route
          path="/announcement/:eventName"
          element={<SingleAnnouncement />}
        />
      </Routes>
      <Footer />
    </Router>
  );
}

function App() {
  // WRAP the entire application in the Splash component
  return (
    <Splash>
      <AppContent />
    </Splash>
  );
}

export default App;